module.exports = __webpack_public_path__ + "static/media/percent-funds-color.862b0840.png";